/** external **/
import React from "react";
import classNames from "classnames";
import { DeleteOutlined } from "@toddle-edu/ds-icons";
import { IconButton } from "@toddle-edu/ds-web";

/** relative **/
import classes from "./Separator.scss";

const Separator = props => {
  const {
    isCreateMode,
    deleteQuestion,
    disableSeparator,
    isGeneratingAIQuestions,
    isStudentEndMode,
  } = props;
  const separatorContainerClasses = classNames({
    [classes.separatorContainer]: true,
    [classes.separatorContainerCreate]: isCreateMode,
    [classes.marginContainer]: !(
      isCreateMode ||
      isGeneratingAIQuestions ||
      isStudentEndMode
    ),
    [classes.disableSeparator]: disableSeparator,
  });

  return (
    <div className={separatorContainerClasses}>
      <hr className={classes.separator} />
      {isCreateMode && (
        <IconButton
          dsVersion="2.0"
          variant="neutral"
          type="plain"
          size="x-small"
          className={classes.deleteIcon}
          icon={<DeleteOutlined />}
          onClick={deleteQuestion}
          testId="worksheet-questionType-delete-icon"
        />
      )}
    </div>
  );
};

export default Separator;
